import { render, staticRenderFns } from "./apiGemJewelryList.vue?vue&type=template&id=81c612a4&scoped=true&"
import script from "./apiGemJewelryList.vue?vue&type=script&lang=js&"
export * from "./apiGemJewelryList.vue?vue&type=script&lang=js&"
import style0 from "./apiGemJewelryList.vue?vue&type=style&index=0&id=81c612a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c612a4",
  null
  
)

export default component.exports